import logoImage from '../../assets/images/dark-main-pro.png';

/**
 * Draws a simple PDF header with logo and company name (no background)
 * This is a jsPDF utility function, NOT a React component
 * 
 * @param {jsPDF} doc - The jsPDF document instance
 * @param {string} companyName - The company name to display
 * @param {number} pageWidth - The width of the page
 * @param {number} margin - The margin size
 * @param {object} colors - Color palette object
 * @returns {number} - The Y position after the header (for content to start)
 */
export const drawCommonPdfHeader = (doc, companyName, pageWidth, margin = 46, colors) => {
  // Default colors if not provided
  const headerColors = colors || {
    black: [33, 37, 41],
    gray: [108, 117, 125],
    borderGray: [222, 226, 230],
    blue: [0, 123, 255], // Link color
  };

  const headerStartY = 20;

  // Add logo on the left
  if (logoImage) {
    try {
      const logoX = margin;
      const logoY = headerStartY;
      const logoWidth = 120;
      const logoHeight = 34;
      
      doc.addImage(logoImage, 'PNG', logoX, logoY, logoWidth, logoHeight);
      
      // Add clickable website link under the logo
      const websiteText = "www.lawsuit-pro.com/";
      const websiteY = logoY + logoHeight + 10; // 10pt below logo
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(...headerColors.gray);
      doc.textWithLink(websiteText, logoX, websiteY, { url: websiteText });
      
    } catch (error) {
      console.error("Error adding logo to PDF:", error);
    }
  }

  // Add company name text on the right
  const rightX = pageWidth - margin;
  const textY = headerStartY + 20;
  
  // "This Software is Licensed to:" text in italic gray
  doc.setFont("helvetica", "italic");
  doc.setFontSize(12);
  doc.setTextColor(...headerColors.gray);
  const licensedText = `Licensed to: ${companyName}`;
  doc.text(licensedText, rightX, textY, { align: "right" });

  // Draw a thin border line at the bottom of header
  // Adjusted to accommodate the website link
  const lineY = headerStartY + 55; // Increased from 40 to 55 to make room for link
  doc.setDrawColor(...headerColors.borderGray);
  doc.setLineWidth(1);
  doc.line(margin, lineY, pageWidth - margin, lineY);

  // Return the Y position where content should start (after the line)
  return lineY + 10; // Height of the header + small padding
};

export default drawCommonPdfHeader;